var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#E4E5E6"}},[(!_vm.loggedIn)?_c('Login'):_vm._e(),(_vm.loggedIn)?_c('Layout'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }